import SbButton from '@Components/Button';
import CopyCredentials from '@Components/CopyCredentials';
import Image from '@Components/Image';
import Modal from '@Components/Modal';
import SbTextField from '@Components/Textfield';

import { CloseRounded } from '@mui/icons-material';
import { Box, IconButton, Link, Stack, Typography } from '@mui/material';
import { sendInvite } from '@Reducers/Squad/actions';
import { AppDispatch, RootStateType } from '@Store';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function SuccessModal(props: ModalProps) {
  const { open, onClose, copyObj, squadId } = props;
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const OrgSetup = useSelector((state: RootStateType) => state.orgSetup);
  const organizationName = OrgSetup.organizationData?.name || 'your organization';
  const textForWhatsapp = `Username:${copyObj.username}%0APassword:${copyObj.password}`;
  const credentialsToShareOnWhatsApp = `You have been invited to join the ${organizationName} team as part of the squad.%0AOrganization: ${organizationName}%0A%0AYour login credentials are as follows:%0A${textForWhatsapp}%0A%0ANote: Do not share this message with anyone outside the organization.`;

  const [inputValue, setInputValue] = useState<string>('');
  const handleInput = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setInputValue(e.target.value);
  };

  const sendInviteClick = async () => {
    await dispatch(sendInvite({ email: inputValue, squadId }));
    onClose();
    navigate('/squad');
  };

  return (
    <Modal open={open} onClose={onClose} maxWidth="md">
      <Box>
        <Stack>
          <IconButton onClick={onClose} sx={{ width: 36, ml: 'auto', fontSize: 36 }}>
            <CloseRounded />
          </IconButton>
        </Stack>

        <Typography className="font-medium l-text">You’ve successfully created an account!</Typography>
        <Typography variant="h6" className="mt-1 md-text font-normal">
          Share account credentials to give access to the squad member
        </Typography>
        <Stack className="my-4" direction={'row'} gap={2}>
          <SbTextField
            sx={{ width: 300 }}
            name="password"
            placeholder="contact@email.com"
            value={inputValue}
            onChange={handleInput}
            endAdornment={
              <IconButton
                onClick={() => {
                  setInputValue('');
                }}
                sx={{ width: 36, ml: 'auto', fontSize: 36 }}
              >
                <CloseRounded />
              </IconButton>
            }
          />
          <SbButton
            variant="contained"
            onClick={sendInviteClick}
            sx={{
              borderRadius: '10px !important',
            }}
          >
            Send Invite
          </SbButton>
        </Stack>
        <Stack className="py-2" direction={'row'} gap={4}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            {/* <ContentCopyRounded
              sx={{
                fontSize: 32,
              }}
            />
            <Typography
              variant="subtitle1"
              className="mt-1 sm-text font-normal"
              sx={{
                lineHeight: 1.3,
              }}
            >
              Copy Admin <br />
              Credentials
            </Typography> */}
            <CopyCredentials
              label="Copy Admin Credentials"
              textToCopy={`Username: ${copyObj.username}, Password: ${copyObj.password}`}
            ></CopyCredentials>
          </Stack>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <Link
              href={`https://web.whatsapp.com/send?text=${credentialsToShareOnWhatsApp}`}
              underline="none"
              target="_blank"
              rel="nofollow noopener"
            >
              <Image src="/images/icons/social_media/WhatsApp.svg" alt="WhatsApp" />
              <Typography className="xs-text  mt-1\/2">WhatsApp</Typography>
            </Link>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
}

export default SuccessModal;

interface ModalProps {
  open: boolean;
  onClose: () => void;
  copyObj: {
    username: string;
    password: string;
  };
  squadId: string;
}
